import { State, Filter } from '../../interfaces'
import { ISearchOTInbound, OtInbound } from '../../interfaces/Planner/Planner'
import { SortField } from '../../interfaces/DataGrid/DataGridSettings'
import { SnackbarState } from '../../interfaces/Generic/State'

export const searchInitialState: ISearchOTInbound = {
  searchField: '',
  searchValue: '',
  searchFieldSecondary: '',
  searchValueSecondary: '',
}

type Action<GridType, SearchType> =
  | { type: 'SHOW_MODAL'; payload: boolean }
  | { type: 'SWITCH_MODAL'; payload: JSX.Element }
  | { type: 'CHANGE_PAGE'; payload: number }
  | { type: 'CHANGE_PAGE_SIZE'; payload: number }
  | { type: 'SET_TOTAL_ITEMS'; payload: number }
  | { type: 'SET_ROWS'; payload: GridType[] }
  | { type: 'SET_BUSQUEDA'; payload: SearchType }
  | { type: 'SET_FILTERS'; payload: Filter[] }
  | { type: 'SET_IS_LOADING'; payload: boolean }
  | { type: 'SWITCH_MODAL_ORDER_CONFIRMATION'; payload: boolean }
  | { type: 'ADD_CHECKBOX_ARRAY'; payload: number[] }
  | { type: 'SET_MESSAGE_STATUS'; payload: string }
  | { type: 'SWITCH_SNACKBAR'; payload: boolean }
  | { type: 'SET_MESSAGE_COLOR'; payload: string }
  | { type: 'SET_IS_LOADING_CONFIRM'; payload: boolean }
  | { type: 'SEARCH_RESET'; payload: null }
  | { type: 'SHOULD_SEARCH'; payload: false }
  | { type: 'SET_SORTERS'; payload: SortField[] }
  | { type: 'SET_EDIT_ITEM'; payload: GridType }
  | { type: 'SWITCH_SNACKBAR_STATE'; payload: SnackbarState }

export const reducerInitialState: State<OtInbound, ISearchOTInbound> = {
  page: 0,
  rowsPerPage: 5,
  totalItems: 0,
  rows: [],
  busqueda: searchInitialState,
  filters: [],
  isLoading: false,
  checkboxArray: [],
  openSnackbar: false,
  messageColor: '',
  messageStatus: '',
  shouldSearch: false,
  sorters: [],
  modal: undefined,
  showModal: false,
  editItem: undefined,
  snackbar: {
    duration: 3000,
    open: false,
    status: 'success',
    message: ''
  }
}

export const otInboundReducer = (
  state: State<OtInbound, ISearchOTInbound>,
  action: Action<OtInbound, ISearchOTInbound>
) => {
  switch (action.type) {
    case 'SHOW_MODAL':
      return {
        ...state,
        showModal: action.payload
      }
    case 'CHANGE_PAGE':
      return {
        ...state,
        page: action.payload
      }
    case 'CHANGE_PAGE_SIZE':
      return {
        ...state,
        rowsPerPage: action.payload
      }
    case 'SET_TOTAL_ITEMS':
      return {
        ...state,
        totalItems: action.payload
      }
    case 'SET_ROWS':
      return {
        ...state,
        rows: action.payload
      }
    case 'SET_BUSQUEDA': {
      return {
        ...state,
        busqueda: action.payload
      }
    }
    case 'SET_FILTERS': {
      return {
        ...state,
        page: 0,
        shouldSearch: true,
        filters: action.payload
      }
    }
    case 'SET_IS_LOADING': {
      return {
        ...state,
        isLoading: action.payload
      }
    }

    case 'ADD_CHECKBOX_ARRAY': {
      return {
        ...state,
        checkboxArray: action.payload
      }
    }
    case 'SWITCH_SNACKBAR':
      return {
        ...state,
        openSnackbar: action.payload
      }
    case 'SET_MESSAGE_COLOR':
      return {
        ...state,
        messageColor: action.payload
      }
    case 'SET_MESSAGE_STATUS':
      return {
        ...state,
        messageStatus: action.payload
      }
    case 'SEARCH_RESET':
      return {
        ...state,
        busqueda: searchInitialState
      }
    case 'SHOULD_SEARCH':
      return {
        ...state,
        shouldSearch: action.payload // true or false
      }
    case 'SET_SORTERS':
      return {
        ...state,
        sorters: action.payload // true or false
      }
    case 'SWITCH_MODAL':
      return {
        ...state,
        modal: action.payload
      }
    case 'SET_EDIT_ITEM':
      return {
        ...state,
        editItem: action.payload
      }
    case 'SWITCH_SNACKBAR_STATE':
      return {
        ...state,
        snackbar: action.payload
      }
    default:
      return state
  }
}
